const orderDefaults = {
  defaultDeliveryFee: 2.5,
  defaultCollateralPercentage: 0.5
};

const GAS_LIMIT = 1000000;

export { orderDefaults, GAS_LIMIT }
